export default class BasePostGridSlider
{
    /**
     * @var {HTMLElement}
     */
    carousel = null;

    /**
     * @var {HTMLElement}
     */
    carouselWrapper = null;

    /**
     * @var {HTMLElement[]}
     */
    slides = [];

    /**
     * @var {Number}
     */
    originalSlides = 0;

    /**
     * @var {Number}
     */
    currentDotIndex = 0;

    /**
     * @var {Number}
     */
    currentSlide = 0;

    /**
     * @var {bool}
     */
    lastSlide = false;

    /**
     * @var {Boolean}
     */
    overflow = false;

    /**
     * @var {Number}
     */
    autoplay = 0;

    /**
     * @var {Boolean}
     */
    infinite = false;

    /**
     * @var {Number}
     */
    slidesInView = 1;

    /**
     * @var {Boolean}
     */
    preview = false;

     /**
     * @var {Number}
     */
     startX = 0;

     /**
      * @var {Number}
      */
     startY = 0;
 
     /**
      * @var {Number}
      */
     initialScroll = 0;

    /**
     * @var {Number}
     */
    currentTranslate = 0;

    /**
     * @var {Number}
     */
    slideXTotal = 0;

    /**
     * @var {Number}
     */
    prevTranslate = 0;

    /**
     * @var {Boolean}
     */
    isChanging = false;

    /**
     * @var {string}
     */
    slidePosition = 'start';

    /**
     * click to drag features
     */
    isDragging = false;
    
    /**
     * @var {Boolean}
     */
    dragThresholdExceeded = false;

    onDragStart = this.onDragStart.bind(this);
    onDragMove = this.onDragMove.bind(this);
    onDragEnd = this.onDragEnd.bind(this);
    dragThresholdExceeded = false;

    /**
     * @var {object}
     */
    currentFilters = {};

    /**
     * @var {HTMLElement}
     */
    postGrid = null;

    /**
     * @var {int}
     */
    totalWidth = 0;

    /**
     * @var {boolean}
     */
    isLoading = false;

    /**
     * @var {object}
     */
    currentFilters = {};

    /**
     * @var {HTMLElement}
     */
    postGrid = null;

    /**
     * @var {object}
     */
    filterPrefix = {
        'taxonomy': 'filter-t-',
        'meta' : 'filter-m-',
        'search': '',
    };

     /**
     * @var {Boolean}
     */
     dragged = false;

    /**
     * @var {boolean}
     */
    updateHistory = true;

     /**
      * constructor
      * @var {Boolean}
      * @var {Number}
      * @var {Boolean}
      * @var {String}
      */
    constructor(autoplay, infinite, slidesInView, overflow = false) {
        this.autoplay = parseInt(autoplay * 1000);
        this.infinite = infinite;
        this.slidesInView = Math.ceil(slidesInView);
        this.overflow = overflow;
    }

    /**
     * init
     * 
     * @return void
     */
    init() {

        this.postGrid = this.$el;
        this.currentFilters = this.getCurrentFilters();
        
        this.carousel = this.$el.querySelector(".Carousel");
        this.carouselWrapper = this.$el.querySelector(".Carousel__Wrapper");

        if (!this.carousel) return;

        this.slides = [...this.carousel.children];

        // Disable dragging on all <a> tags within the slides
        this.slides.forEach(slide => {
            if (slide.tagName === "A") {
                slide.setAttribute("draggable", "false");
                slide.addEventListener('click', (event) => {
                    if (this.dragged) {
                        event.preventDefault();
                        this.dragged = false;
                    }
                });
                return;
            };
            const links = slide.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('draggable', 'false');
                link.addEventListener('click', (event) => {
                    if (this.dragged) {
                        event.preventDefault();
                        this.dragged = false;
                    }
                });
            });
        });

        this.originalSlides = this.slides.length;

        if (this.infinite && !this.preview) {
            this.cloneSlides();
        }

        if (
            !this.infinite &&
            this.overflow &&
            this.slides.length > this.slidesInView
        ) {
            this.containerResize();
        }

        pegasus.onResizeFinished(() => {
            this.goToSlide(this.currentSlide);
            this.getSlideXTotal();
            this.updateProgressBar();
            this.isChanging = false;
        }, true);

        // Add event listeners for dragging and scrolling
        if (!this.preview) {
            this.carousel.addEventListener("mousedown", this.onDragStart);
            this.carousel.addEventListener("touchstart", this.onDragStart, { passive: true });

            this.carousel.querySelectorAll("a, img").forEach((el) => {
                el.addEventListener("dragstart", (e) => e.preventDefault());
            });

            let scrollTimeout;
            
            this.carouselWrapper.addEventListener("wheel", (event) => {
                
                // Ignore vertical scrolling
                if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
            
                // Add dragging class to prevent transition
                this.carousel.classList.add("dragging");
                
                this.handleFreeScroll(event.deltaX);

                // Make sure to snap to nearest slide after scrolling
                clearTimeout(scrollTimeout);

                scrollTimeout = setTimeout(() => {
                    this.carousel.classList.remove("dragging");
                    // Determine the closest slide to snap to based on the current translation
                    const closestSlideIndex = this.getClosestSlideIndex(
                        this.currentTranslate
                    );

                    // Snap to the closest slide
                    this.goToSlide(closestSlideIndex);
                }, 100);
            }, { passive: true });
        }

        this.carousel.addEventListener("transitionend", () => {
            this.handleInfiniteScroll();
            setTimeout(() => {
                this.isChanging = false;
            }, 300);
        });

        this.isChanging = false;

    };

    initAutoplay() {
        if (this.autoplay && !this.preview) {
            setInterval(() => {
                this.nextSlide();
            }, this.autoplay);
        } else {
            return;
        }
    }

    getSlideXTotal() {
        // Loop through this.slides and get the total width of all the slides added together
        this.slideXTotal = 0;
        this.slides.forEach((slide) => {
            this.slideXTotal += slide.offsetWidth;
        });
    }

    /**
     * Clone sets of slides to create an infinite looping effect with multiple visible slides
     */
    cloneSlides() {
        const firstClones = this.slides
            .slice(0, this.slidesInView)
            .map((slide) => slide.cloneNode(true));
        const lastClones = this.slides
            .slice(-this.slidesInView)
            .map((slide) => slide.cloneNode(true));

        firstClones.forEach((clone) => this.carousel.appendChild(clone));
        lastClones.forEach((clone) =>
            this.carousel.insertBefore(clone, this.slides[0])
        );

        this.slides = [...this.carousel.children]; // Update slides array
        this.currentSlide = this.slidesInView; // Start at the first real slide set
        this.goToSlide(this.currentSlide, false); // Position slider to start
    }

    handleInfiniteScroll() {
        if (!this.infinite || this.preview) return;

        let slideOffset = 0;

        let firstSlide = 0 + slideOffset;
        let lastSlide = this.slides.length - this.slidesInView;

        if (this.currentSlide === firstSlide) {
            const goTo =
                this.slides.length - this.slidesInView * 2 + slideOffset;
            this.goToSlide(goTo, false);
            this.isChanging = false;
        }

        if (this.currentSlide === lastSlide) {
            this.goToSlide(this.slidesInView, false);
            this.isChanging = false;
        }
    }

    handleFreeScroll(scroll) {
        // Move the slider based on the scroll amount, to mimic normal scroll behaviour
        const distance = this.getSliderCurrentTranslate() + scroll;
        if (distance > 0) {
            this.carousel.style.transform = `translateX(0)`;
            return;
        }

        if(Math.abs(distance) > this.slideXTotal - this.carouselWrapper.offsetWidth){
            this.carousel.style.transform = `translateX(-${this.slideXTotal - this.carouselWrapper.offsetWidth}px)`;
            return;
        }

        this.carousel.style.transform = `translateX(${distance}px)`;

        this.currentTranslate = distance;
        
        this.updateProgressBar();

    };

    /**
     * nextSlide
     * @param {Number}
     * @return void
     */
    nextSlide(slidesToScroll = 1) {
        // Check if the last slide is fully visible
        const maxTranslate = this.slideXTotal - this.carouselWrapper.offsetWidth;
        if (Math.abs(this.getSliderCurrentTranslate()) >= maxTranslate && !this.infinite) {
            return;
        }
    
        this.goToSlide(this.currentSlide + slidesToScroll);
    }

    /**
     * previousSlide
     * @param {Number}
     * @return void
     */
    previousSlide(slidesToScroll = 1) {
        if (this.currentSlide - slidesToScroll < 0) {
            return;
        }
        this.goToSlide(this.currentSlide - slidesToScroll);
    }

    /**
     * goToSlide
     * @param {Number} slide
     * @return void
     */
    goToSlide(slide, animate = true) {
        if (this.isChanging) {
            return;
        }

        this.currentSlide = slide;

        const realSlideIndex = (this.currentSlide - this.slidesInView) % this.originalSlides;
        this.currentDotIndex = realSlideIndex < 0 ? this.originalSlides + realSlideIndex : realSlideIndex;

        this.scrollSlide(slide, animate);

        this.setCurrentSlideClass();

        this.updateProgressBar();

        window.dispatchEvent(new CustomEvent('updateslideindex', { detail: { slideIndex: this.getCurrentSlide() } }));

        this.isChanging = false;

        window.dispatchEvent(new CustomEvent('updateslideindex', { detail: { slideIndex: this.getCurrentSlide() } }));
    }

    scrollSlide(slide, animate) {

        if(slide + 1 === this.slides.length) {
            this.lastSlide = true;
        } else {
            this.lastSlide = false;
        }

        const selectedSlide = this.slides[slide];

        // get the x position of the selected slide
        let slideX = selectedSlide.getBoundingClientRect().left;
        const currentTranslate = this.getSliderCurrentTranslate();
        // get the x position of the this.carouselWrapper
        let wrapperX = this.carouselWrapper.getBoundingClientRect().left;

        // calculate the distance to translate
        let distance = wrapperX - slideX + currentTranslate;

        if (slide === 0) {
            distance = 0;
        }

        if (slide === this.slides.length - 1) {
            slideX = selectedSlide.getBoundingClientRect().right;
            wrapperX =
                this.carouselWrapper.getBoundingClientRect().left +
                this.carouselWrapper.offsetWidth;
            distance = wrapperX - slideX + currentTranslate;
        }

        const maxTranslate = this.slideXTotal - this.carouselWrapper.offsetWidth;

        if(maxTranslate > 0 && Math.abs(distance) >= maxTranslate && !this.infinite) {
            distance = -Math.abs(maxTranslate);
            this.lastSlide = true;
        } 

        this.isChanging = true;

        if (!animate) {
            this.carousel.classList.add("no-transition");
        }

        this.carousel.style.transform = `translateX(${distance}px)`;

        if (!animate) {
            this.carousel.offsetWidth; // Trigger reflow
            this.carousel.classList.remove("no-transition");
        }
    }

    /**
     * Handle drag start
     */
    onDragStart(event) {
        if (event.target.tagName === "A" || event.target.tagName === "VIDEO") {
            event.preventDefault();
        }

        this.isDragging = true;
        this.carousel.classList.add("dragging");
        this.startX = event.type.includes("mouse")
            ? event.pageX
            : event.touches[0].clientX;
        this.startY = event.type.includes("mouse")
            ? event.pageY
            : event.touches[0].clientY;
        this.prevTranslate = this.getSliderCurrentTranslate();
        this.dragThresholdExceeded = false;
        this.dragged = false;

        // Store the initial scroll position
        this.initialScroll = window.scrollY;

        // Attach move and end listeners
        this.carouselWrapper.addEventListener("mousemove", this.onDragMove);
        this.carouselWrapper.addEventListener("touchmove", this.onDragMove, {
            passive: true,
        });
        this.carouselWrapper.addEventListener("mouseup", this.onDragEnd);
        this.carouselWrapper.addEventListener("touchend", this.onDragEnd);
    }

    /**
     * Handle drag move - continuously update translation to follow cursor
     */
    onDragMove(event) {
        if (!this.isDragging) return;

        const currentX = event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
        const currentY = event.type.includes("mouse") ? event.pageY : event.touches[0].clientY;
        
        // Calculate X and Y movement
        const deltaX = currentX - this.startX;
        const deltaY = currentY - this.startY;
        
        const distanceMoved = currentX - this.startX;

        // Check if the threshold has been exceeded
        if (!this.dragThresholdExceeded && Math.abs(distanceMoved) < 10) {
            return;
        }

        this.dragThresholdExceeded = true;

        // If vertical scrolling is detected, stop the drag
        if (Math.abs(deltaY) > Math.abs(deltaX) * 1.5) {
            this.onDragEnd();
            return;
        }

        // Prevent page scroll while dragging horizontally
        if (Math.abs(deltaX) > 10) {
            window.scrollTo(0, this.initialScroll);
        }

        // Update the current translate to follow the mouse movement exactly
        this.currentTranslate = this.prevTranslate + distanceMoved;

        if(window.outerWidth >= 768) {
            this.carousel.style.transform = `translateX(${this.currentTranslate}px)`;
        }

        // If the mouse leaves this.carouselWrapper, end the drag
        this.carouselWrapper.addEventListener("mouseleave", this.onDragEnd);
        this.carouselWrapper.addEventListener("touchleave", this.onDragEnd);
    }

    /**
     * Handle drag end and snap to nearest slide
     */
    onDragEnd() {
        if (!this.dragThresholdExceeded) {
            // If the threshold was not exceeded, treat it as a click and do nothing
            this.isDragging = false;
            this.carousel.classList.remove("dragging");
            this.carouselWrapper.removeEventListener(
                "mousemove",
                this.onDragMove
            );
            this.carouselWrapper.removeEventListener(
                "touchmove",
                this.onDragMove,
                { passive: true }
            );
            this.carouselWrapper.removeEventListener(
                "mouseleave",
                this.onDragEnd
            );
            this.carouselWrapper.removeEventListener(
                "touchleave",
                this.onDragEnd,
                { passive: true }
            );
            return;
        }

        this.isDragging = false;
        this.dragged = true;

        // Determine the closest slide to snap to based on the current translation
        const closestSlideIndex = this.getClosestSlideIndex(
            this.currentTranslate
        );

        // Snap to the closest slide
        this.goToSlide(closestSlideIndex);

        this.carousel.classList.remove("dragging");

        window.dispatchEvent(
            new CustomEvent("updateslideindex", {
                detail: { slideIndex: this.getCurrentSlide() },
            })
        );

        this.carouselWrapper.removeEventListener("mousemove", this.onDragMove);
        this.carouselWrapper.removeEventListener("touchmove", this.onDragMove, {
            passive: true,
        });
        this.carouselWrapper.removeEventListener("mouseleave", this.onDragEnd);
        this.carouselWrapper.removeEventListener("touchleave", this.onDragEnd, {
            passive: true,
        });

        this.isChanging = false;
    }

    /**
     * Determine the index of the slide closest to the current position
     * @param {Number} currentTranslate - The current translation position of the slider
     * @return {Number} The index of the closest slide
     */
    getClosestSlideIndex(currentTranslate) {
        let closestIndex = this.currentSlide;
        let minDistance = Infinity;

        this.slides.forEach((slide, index) => {
            // Calculate the slide’s position relative to the carousel wrapper
            let slidePosition =
                slide.offsetLeft - this.carouselWrapper.offsetLeft;

            // Calculate the distance from current position to slide position
            const distance = Math.abs(slidePosition + currentTranslate);

            // Update the closest slide if this one is closer
            if (distance < minDistance) {
                minDistance = distance;
                closestIndex = index;
            }
        });

        return closestIndex;
    }

    /**
     * getSliderCurrentTranslate
     * @return {Number}
     */
    getSliderCurrentTranslate() {
        const style = window.getComputedStyle(this.carousel);
        const matrix = new WebKitCSSMatrix(style.transform);

        return matrix.m41;
    }

    /**
     * containerResize
     *
     * Description: In order to get the slider to break out of its parent container
     * we need to set the width of the slider to be larger than the container.
     *
     * @return void
     */
    containerResize() {
        const container = this.$root.closest(".container");

        if (!container || window.outerWidth < 768) return;

        if (!this.carousel) return;

        // We need to get the width of the container excluding padding
        let widthWithPaddings = container.clientWidth;
        const elementComputedStyle = window.getComputedStyle(container, null);

        const containerWidth =
            widthWithPaddings -
            parseFloat(elementComputedStyle.paddingLeft) -
            parseFloat(elementComputedStyle.paddingRight);

        const containerVw = (containerWidth / window.innerWidth) * 100;

        // If the align is full, center or wide we need to set the slider to be the full width of the container
        let divider = 2;

        const carouselWidth = 100 - (100 - containerVw) / divider;

        this.carousel.style.width = `${carouselWidth}vw`;
    }

    setCurrentSlideClass() {
        this.slides.forEach((slide, index) => {
            if (index === this.currentSlide) {
                slide.classList.add("is-selected");
            } else {
                slide.classList.remove("is-selected");
            }
        });
    }

    getSlideCount() {
        return this.originalSlides;
    }

    getCurrentSlide() {
        return this.infinite ? this.currentDotIndex : this.currentSlide;
    }


    /**
     * updateProgressBar
     * 
     * @return void
     */
    updateProgressBar() {
        const progressBar = this.$refs.progressBar;
        if(!progressBar) return;
        const progress = ( Math.abs( this.getSliderCurrentTranslate() ) / ( this.slideXTotal - this.carouselWrapper.offsetWidth ) ) * 100;
        progressBar.style.width = progress + "%";
    };

    /**
     * toggleFilters
     * 
     * Description: Either add or remove the filter term from 
     * it's taxonomy.
     * 
     * @param {string} term
     * @param {string} filterName
     * @param {string} type
     * @return void
     */
    toggleFilters(term = '', filterName = '', type = 'taxonomy'){

        const filter = this.getPrefixedFilter(filterName, type);

        // If this is the first filter to be added, just add it.
        if(typeof this.currentFilters[filter] === "undefined"){
            this.currentFilters[filter] = term;

            // Refresh the post grid content
            this.fetchContent();
            return;
        }

        // If we have filters for the current filter, check if the term is already in the list.
        if(this.currentFilters[filter].length){

            if(this.currentFilters[filter].includes(term)) {
                // If the term is already in the list, remove it from the filter.
                this.currentFilters[filter] = this.removeFilter(filter, term);
                // If this filter filter is now empty, remove it from the current filters.
                if(!this.currentFilters[filter].length){
                    delete this.currentFilters[filter];
                }
            } else {
                // If the term is not already in the list, add it.
                this.currentFilters[filter] += ','+term
            }
        } else {
            // If there isn't a filter for this filter, add it and then add the term to it.
            this.currentFilters[filter] = term;
        }

        // Refresh the post grid content
        if(fetch){
            this.fetchContent();
        }

    }

    /**
     * removeFilter
     * 
     * Description: Removes a given term from it's taxonomy filter.
     * 
     * @param {string} filter
     * @param {string} value
     * @return string
     */
    removeFilter(filter, value){
        // Get the filter values from the currentFilters array
        const filterValue = this.currentFilters[filter];

        // Turn the filter values into an array
        const filterValueArray = filterValue.split(',');

        // Loop through the array and remove the given value
        for(let i = 0; i < filterValueArray.length; i++){
            if (filterValueArray[i] === value) { 
                filterValueArray.splice(i, 1); 
            }   
        }

        // Return the array as a string
        return filterValueArray.toString();
    }

    /**
     * clearFilters
     * 
     * Description: Empty the current filters and refresh the page.
     * 
     * @return void
     */
    clearFilters() {
        this.currentFilters = {};
        window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    }

    /**
     * fetchContent
     * 
     * Description: Requests the new post grid based on the current 
     * filters and replaces the current post grid with it's content.
     * 
     * @param {string} href
     * @return void
     */
    fetchContent(href = null){

        // Get the post grid container and the data selector for the post grid.
        const postGrid = this.postGrid.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="'+postGrid.dataset.pegasusFilterable+'"'];
        let currentUrl = '';

        // If there are no filters, just refresh the page.
        if(!Object.keys(this.currentFilters).length){
            if(href){
                currentUrl = href;
            } else {
                window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
                return;
            }
            
        } else {
            // If there are filters, build the url and set it as the current url.
            currentUrl = this.buildUrl();
        }

        // If a href is passed in, use that instead of the current url.
        if(href){
            currentUrl = href;
        }
        
        // Only allow a request to happen whilst we're not waiting for a response.
        if(!this.isLoading){
            this.isLoading = true;
            // Run the ajaxContent function from pegasus.
            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                // rebuild the slider
                this.initSlider();

                // Update the url with the current filters.
                if(this.updateHistory) {
                    history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);
                }

                // Scroll to the top of the post grid.
                pegasus.scroll(this.postGrid);

                // If the post grid items open in modals make sure to re-initialise them.
                if(typeof window.modal !== "undefined"){
                    window.modal.init();
                }

            });
        }
    }

    /**
     * getCurrentFilters
     * 
     * Description: Get the current filters from the url.
     * 
     * @return object
     */
    getCurrentFilters(){
        // Get the current url and parse the query string.
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        let currentFilters = {};

        // Loop through the query string and add each filter to the currentFilters object.
        for (const [key, value] of params.entries()) {
            currentFilters[key] = value;
        }

        return currentFilters;

    }

    /**
     * filterIsActive
     * 
     * Description: Checks if a given filter is currently selected.
     * 
     * @param {string} filter
     * @param {string} term
     * @param {string} type
     * @return {boolean}
     */
    filterIsActive(term, filter, type = 'taxonomy'){
        const filterName = this.getPrefixedFilter(filter, type);
        if(typeof this.currentFilters[filterName] !== "undefined"){
            return this.currentFilters[filterName].includes(term);
        }
        return false;
    }

    /**
     * buildUrl
     * 
     * Description: Build the URL to request from based on the current filters.
     * 
     * @return void
     */
    buildUrl(){
        // Set the URL to the current page.
        let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?';
        let i = 1

        // Loop through the filters and add them to the URL
        for (const [key, value] of Object.entries(this.currentFilters)) {
            url += `${key}=${value}`
            if(i < Object.keys(this.currentFilters).length){
                url+='&'
            }
            i++
        }

        return url;
    }

    /**
     * getPrefixedFilter
     * @param {string} filter
     * @param {string} type
     * @return {string}
     */
    getPrefixedFilter(filter, type = 'taxonomy'){
        return `${this.filterPrefix[type]}${filter}`;
    }

}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", (autoplay, infinite, slidesInView) => new BasePostGridSlider(autoplay, infinite, slidesInView));
});
